import { Auth } from "aws-amplify";
import { SignUpService } from "../../Provider";

export async function LoginService(loginModel) {
  return Auth.signIn(loginModel.email, loginModel.password);
}

export async function LogoutService() {
  return Auth.signOut();
}

export async function UserSignUpService(userInfo){
  return SignUpService(userInfo);
}
